import "leaflet/dist/leaflet.css";
import "leaflet-ruler/src/leaflet-ruler.css";
import L from "leaflet";
import { createLayerComponent } from "@react-leaflet/core";
import { authGet, safeAxiosGet } from "../Authentication";

async function getTile(url: string) {
  const cache = await caches.open('tile-cache')
  let preSignedUrl = ""

  const cacheResponse = await cache.match(url)
  if (!cacheResponse) {
    const response = await authGet(url)
    if (!response) {
      return null;
    }
    preSignedUrl = response.data.url
  } else {
    preSignedUrl = await cacheResponse.text()
  }

  const axios_response = await safeAxiosGet(preSignedUrl, { responseType: "blob" })
  if (axios_response === undefined || axios_response === null) {
    return null;
  }

  try {
    const image = URL.createObjectURL(axios_response.data);
    if (!await cache.match(preSignedUrl)) {
      const blob = new Blob([axios_response.data], { type: 'image/png' });
      await cache.put(url, new Response(preSignedUrl));
      await cache.put(preSignedUrl, new Response(blob));
    }
    return image
  }
  catch { return null; }
}


class Authorized extends L.TileLayer {

  public static createAuthorizedLayer(props: any, context: any) {
    const instance = new Authorized(props.url, { ...props } as L.TileLayerOptions);
    return { instance, context };
  }

  public static updateAuthorizedLayer(instance: any, props: any, prevProps: any) {
    if (prevProps.opacity !== props.opacity) {
      if (instance.setOpacity) {
        instance.setOpacity(props.opacity);
      }
    }
    if (prevProps.zIndex !== props.zIndex) {
      if (instance.setZIndex) {
        instance.setZIndex(props.zIndex);
      }
    }
  }

  createTile(coords: L.Coords, done: (p1: any, p2: HTMLImageElement) => void) {
    const url = this.getTileUrl(coords);
    const img = document.createElement("img");

    getTile(url).then((data) => {
      if (data !== undefined && data !== null) {
        img.src = data;
        done(null, img);
      }
    })
    return img;
  }
}

export default createLayerComponent(Authorized.createAuthorizedLayer, Authorized.updateAuthorizedLayer);
